import * as React from "react";
import {sortBy} from "lodash";
import PaperLayout from "components/PaperLayout/PaperLayout";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import repository from "client/repository";
import {HostedInstanceLookupResource} from "client/resources/hostedInstanceLookupResource";
import {ReefResource} from "client/resources/reefResource";
import ActionList from "components/ActionList";
import {ActionButtonType} from "components/Button";
import OpenDialogButton from "components/Dialog/OpenDialogButton";
import InstanceEnvironmentVariableDataTable from "./InstanceEnvironmentVariableDataTable";
import AddInstanceEnvironmentVariableDialog from "./AddInstanceEnvironmentVariableDialog";
import {    
    EnvironmentVariableScope,
    InstanceEnvironmentVariable,
    InstanceEnvironmentVariableUsage
} from "client/resources/instanceEnvironmentVariablesResource";

interface State extends DataBaseComponentState {
    environmentVariables?: InstanceEnvironmentVariable[];
    instances?: HostedInstanceLookupResource[];
    reefs?: ReefResource[];
    usageStats?: InstanceEnvironmentVariableUsage[];
}

class InstanceEnvironmentVariables extends DataBaseComponent<{}, State> {
    constructor(props: {}) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.loadData();
    }

    private async loadData() {
        return this.doBusyTask(async () => {
            const environmentVariables = await repository.InstanceEnvironmentVariables.getInstanceEnvironmentVariables();
            const reefs = await repository.Reefs.list();
            const instances = await repository.HostedInstances.lookup();
            repository.InstanceEnvironmentVariables.getUsageStats().then((usageStats) => {
                this.setState({usageStats});
                console.log(usageStats);
            })

            this.setState({
                environmentVariables: sortBy(environmentVariables, f => f.Name.toLowerCase()),
                reefs: reefs,
                instances: instances
            });
        });
    }

    private editEnvironmentVariable = (environmentVariable: InstanceEnvironmentVariable) => {
        return this.doBusyTask(async () => {
            await repository.InstanceEnvironmentVariables.editInstanceEnvironmentVariable(environmentVariable.Id,  environmentVariable.IsEnabled);
            const newState = [...this.state.environmentVariables];
            const index = newState.findIndex(f => f.Id === environmentVariable.Id);
            newState[index] = environmentVariable;
            this.setState({environmentVariables: newState});
        });
    }

    private deleteEnvironmentVariable = (environmentVariable: InstanceEnvironmentVariable) => {
        return this.doBusyTask(async () => {
            await repository.InstanceEnvironmentVariables.deleteInstanceEnvironmentVariable(environmentVariable.Id)
            const newState = [...this.state.environmentVariables];
            const index = newState.findIndex(f => f.Id === environmentVariable.Id);
            newState.splice(index, 1);
            this.setState({environmentVariables: newState});
        });
    }

    private editEnvironmentVariableScope = async (id: string, scope: EnvironmentVariableScope) => {
        await repository.InstanceEnvironmentVariables.editInstanceEnvironmentVariableScope(id, scope);
        await this.loadData();

        return true;
    }

    render() {
        return <PaperLayout title="Instance Environment Variables"
                            busy={this.state.busy}
                            errors={this.state.errors}
                            sectionControl={<ActionList actions={[
                                <OpenDialogButton label={"New environment variable"} type={ActionButtonType.Primary}>
                                    <AddInstanceEnvironmentVariableDialog onAdded={() => { this.loadData(); }} />
                                </OpenDialogButton>
                            ]
                            }/>}
                            fullWidth={true}>
            {this.state.environmentVariables &&
            <InstanceEnvironmentVariableDataTable
                environmentVariables={this.state.environmentVariables}
                editEnvironmentVariables={this.editEnvironmentVariable}
                editEnvironmentVariableScope={this.editEnvironmentVariableScope}
                deleteEnvironmentVariable={this.deleteEnvironmentVariable}
                usageStats={this.state.usageStats}
                instances={this.state.instances}
                reefs={this.state.reefs}
            />}
        </PaperLayout>;
    }
}

export default InstanceEnvironmentVariables;